const TestIds = {
  HEADER: 'twofactor-header',
  CODE_ENTRY_BOX: 'twofactor-codeentry',
  CODE_SUBMIT_BUTTON: 'twofactor-code-submit-button'
};
export default TestIds;